import { ReleaseStatus } from 'services/store/distribution/types';

export const isReleasable = (status: ReleaseStatus) =>
  [ReleaseStatus.DRAFT, ReleaseStatus.DECLINED].includes(status);
